import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PrivateRoute from './private-route/private-route';
import LoginPageWrapper from './login-page-wrapper/login-page-wrapper';
import NotFoundPage from '../pages/not-found-page/not-found-page';
import { QandA, Presenter, Polls, Attendees, BlankPage } from '../components';

const Routes: React.FC = () => {
  const defaultPresentationRoute = '/presentation/:id';

  return (
    <Router>
      <Switch>
        <Route exact path='/404' component={NotFoundPage}/>
        <PrivateRoute component={QandA} path={`${defaultPresentationRoute}/qanda`} exact/>
        <PrivateRoute component={Presenter} path={`${defaultPresentationRoute}/presenter`} exact/>
        <PrivateRoute component={Polls} path={`${defaultPresentationRoute}/polls`} exact/>
        <PrivateRoute component={Attendees} path={`${defaultPresentationRoute}/attendees`} exact/>
        <PrivateRoute component={BlankPage} path={`${defaultPresentationRoute}/blank`} exact/>
        <Route exact path={defaultPresentationRoute} component={LoginPageWrapper}/>
        <Route path='*' component={NotFoundPage}/>
      </Switch>
    </Router>
  );
};

export default Routes;
